<template>
    <div v-if="!isMobile" class="promotions">
        <h3 class="title">{{ langPage['codepromo']['TXT_promotionsh1'] }}</h3>
        <el-divider></el-divider>
        <div class="contianer">
            <div class="leftFilters">
                <promotions-filter :filter-list="filters"
                                   :data-list="discountList"
                                   :total-count="totalCount"
                                   :total-collect-count="totalCollectCount"
                                   @chooseVendeur="onChooseVendeur"></promotions-filter>
            </div>
            <div class="right">
                <el-col v-for="(remise,remiseIndex) of discountList" class="item" :key="remiseIndex"
                        @click.native="$router.push({path: `/vendeur/${remise.id_vendeur}`})">
                    <img v-lazy="`${$common.imgHost}Images/Boutiques/${remise.id_vendeur}/logo-boutique.jpg`"
                         class="logo"
                         alt="">
                    <div v-if="remise.all_reduce_percent" v-for="(percentData,percentIndex) of remise.all_reduce_percent"
                         :key="percentIndex" class="percent">
                        <p>
                            {{ `- ${remise.type === 'pourcentage' ? percentData.montant + '%' : percentData.montant + '€'}` }}
                        </p>
                        <p>{{
                                `${percentData.montant_min ? langPage['catalogue-filtresrecherche']['TXT_montantminimum'] + '>' + percentData.montant_min : langPage['codepromo-liste']['TXT_sansminachat']}`
                            }}</p>
                    </div>
                    <div v-if="!remise.all_reduce_percent" class="percent">
                        <p>
                            {{ `- ${remise.type === 'pourcentage' ? remise.montant + '%' : remise.montant + '€'}` }}
                        </p>
                        <p>{{
                                `${remise.montant_min ? langPage['catalogue-filtresrecherche']['TXT_montantminimum'] + '>' + remise.montant_min : langPage['codepromo-liste']['TXT_sansminachat']}`
                            }}</p>
                    </div>
                    <div style="flex-grow: 1"></div>
                    <p v-if="remise.code" class="remiseCode" @click.stop="">
                        {{ remise.code }}
                    </p>
                    <p v-if="remise.date_fin">
                        {{ langPage['codepromo-liste']['TXT_validejusquau'] + ` ${formatDate(remise.date_fin, '{d}-{m}-{y}')}` }}
                    </p>
                </el-col>
            </div>
        </div>
        <div v-if="is_show_loadMore" class="center" style="width:100%;margin-top:40px">
            <button
                @click="onLoadMoreClick"
                style="margin:0 auto;display:block;width:300px;height:50px;line-height:50px;background:black;color:#fff;border:0;font-size: 10pt"
            >{{ langPage ['compte-commandes-liste']['TXT_voirplus'] }}
            </button>
        </div>
    </div>
    <div v-else class="mpromotions mobileCommon">
        <h3 class="title">{{ langPage['codepromo']['TXT_promotionsh1'] }}</h3>
        <el-divider></el-divider>
        <div class="contianer">
            <div @click="is_show_filter=!is_show_filter" class="blackBtn leftBlackBtn">
                <div align="center" style="font-size: 10pt">{{ langPage['v4-productlist']['TXT_filtres'] }}</div>
            </div>
            <div v-for="(remise,remiseIndex) of discountList" class="item" :key="remiseIndex"
                 @click="$router.push({path: `/vendeur/${remise.id_vendeur}`})">
                <img v-lazy="`${$common.imgHost}Images/Boutiques/${remise.id_vendeur}/logo-boutique.jpg`"
                     class="logo"
                     alt="">
                <div v-if="remise.all_reduce_percent" v-for="(percentData,percentIndex) of remise.all_reduce_percent"
                     :key="percentIndex" class="percent">
                    <p>
                        {{ `- ${remise.type === 'pourcentage' ? percentData.montant + '%' : percentData.montant + '€'}` }}
                    </p>
                    <p>{{
                            `${percentData.montant_min ? langPage['catalogue-filtresrecherche']['TXT_montantminimum'] + '>' + percentData.montant_min : langPage['codepromo-liste']['TXT_sansminachat']}`
                        }}</p>
                </div>
                <div v-if="!remise.all_reduce_percent" class="percent">
                    <p>
                        {{ `- ${remise.type === 'pourcentage' ? remise.montant + '%' : remise.montant + '€'}` }}
                    </p>
                    <p>{{
                            `${remise.montant_min ? langPage['catalogue-filtresrecherche']['TXT_montantminimum'] + '>' + remise.montant_min : langPage['codepromo-liste']['TXT_sansminachat']}`
                        }}</p>
                </div>
                <div style="flex-grow: 1"></div>
                <p v-if="remise.code" class="remiseCode">
                    {{ remise.code }}
                </p>
                <p v-if="remise.date_fin">
                    {{ langPage['codepromo-liste']['TXT_validejusquau'] + ` ${formatDate(remise.date_fin, '{d}-{m}-{y}')}` }}
                </p>
            </div>
        </div>
        <div v-if="is_show_loadMore" class="center" style="width:100%;margin-top:40px">
            <button
                @click="onLoadMoreClick"
                style="margin:0 auto;display:block;width:300px;height:50px;line-height:50px;background:black;color:#fff;border:0;font-size: 10pt"
            >{{ langPage ['compte-commandes-liste']['TXT_voirplus'] }}
            </button>
        </div>


        <!--过滤器filter的抽屉-->
        <el-drawer
            :visible.sync="is_show_filter"
            direction="ltr"
            size="90%">
            <div class="drawerContainer">
                <div class="proBox">
                    <div class="filter">
                        <div style=" position: sticky;top: 0;z-index: 4;">
                            <promotions-filter :filter-list="filters"
                                               :data-list="discountList"
                                               :total-count="totalCount"
                                               :total-collect-count="totalCollectCount"
                                               @chooseVendeur="onChooseVendeur"></promotions-filter>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import promotionsFilter from "@/components/promotionsFilter";
import filterList from "@/components/filterList";

let formatUtils = require('@/utils/format');

export default {
    name: "Promotions",
    components: {
        promotionsFilter
    },
    async mounted() {
        await this.loadMore();
        this.$common.EventBus.$on('loadmore', () => {
            this.pages = 1;
            this.loadMore('change')
        });
        this.getCollectCount();
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            filters: {
                vendeurType: 'all',
            },
            discountList: [],
            tempDiscountList: [],
            pages: 1,
            is_show_loadMore: true,
            langPage: this.$store.state.langPage,
            formatDate: formatUtils.parseTime,
            is_show_filter: false,
            totalCount: 0,
            totalCollectCount: 0,
        }
    },
    methods: {
        async loadMore(type) {
            let params = {
                page: this.pages,
                pageSize: "15",
            };
            console.log('filterList', this.filters);
            if (this.filters.remiseType) params.remiseType = this.filters.remiseType;
            if (this.filters.vendeurType === 'collect') params.isCollect = true;
            if (this.filters.vendeurName) params.vendeurName = this.filters.vendeurName;
            let res = await this.$api.order.getDiscount(params);
            if (type != 'change') {
                this.discountList = this.discountList.concat(res.data.list);
            } else {
                this.discountList = res.data.list;
            }
            Object.assign(this.tempDiscountList, this.discountList);
            if (res.data.page.pageSize > res.data.page.total) {
                this.is_show_loadMore = false;
            }
            if (this.filters.vendeurType == 'all') {
                this.totalCount = res.data.page.total;
            } else if (this.filters.vendeurType == 'collect') {
                this.totalCollectCount = res.data.page.total;
            }
            console.log('discountList', this.discountList);
        },
        onLoadMoreClick() {
            this.pages++;
            this.loadMore();
        },
        onChooseVendeur(data) {
            console.log('chooseVendeur', data);
            if (!data || data.length === 0) data = this.tempDiscountList;
            this.discountList = data;
            this.$forceUpdate();
        },
        async getCollectCount() {
            this.filters.vendeurType = 'collect';
            await this.loadMore();
            this.filters.vendeurType = 'all';

        }
    }
}
</script>

<style lang="less" scoped src="@/assets/viewCss/views/Promotions.less">
</style>
